import { useMemo } from 'react';
import { pick } from 'lodash';
import { useSelector } from 'react-redux';
import { AvailableFilterTypesByView, SearchFilterViews } from 'js/constants/visibilityFilters';
import { applyFilters, processClientSideSearchFilters } from 'js/lib/SearchFilterUtils';
import { useGetServiceKeys } from 'new/components/settings/Authentication/ServiceKeys/useGetServiceKeys';

export function useGetFilteredServiceKeys() {
  const allServiceKeys = useGetServiceKeys();
  const {
    app: {
      visibilityFilters: { filters, availableFilters },
    },
    entities,
    dataSetSchemas,
  } = useSelector((s: any) => s);

  const filtered = useMemo(() => {
    const { filteredObjects } = applyFilters(
      allServiceKeys,
      processClientSideSearchFilters(
        filters[SearchFilterViews.SERVICE_KEYS],
        pick(availableFilters, AvailableFilterTypesByView[SearchFilterViews.SERVICE_KEYS]),
      ),
      entities,
      dataSetSchemas,
    );
    return filteredObjects;
  }, [allServiceKeys, filters]);

  return Object.values(filtered);
}
